import Marquee from "react-fast-marquee";
import { CLIENT_LOGOS } from "@/constants/site";
import { motion } from "framer-motion";

/**
 * Clients strip — replaces the 4-pillar trust bar.
 * Headline + slow marquee of authorized client logos.
 */
export default function Clients() {
  return (
    <section
      id="autoridade"
      data-testid="clients-section"
      className="relative env-soft border-y hairline py-16 md:py-20"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-8 mb-10 md:mb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-end">
          <div className="md:col-span-8">
            <motion.span
              initial={{ opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="kicker block"
            >
              Confiança institucional
            </motion.span>
            <motion.h2
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.05 }}
              className="mt-3 font-display text-[#1A3A61] text-3xl md:text-4xl lg:text-[42px] leading-[1.02] tracking-[-0.02em] max-w-3xl"
            >
              Escolhida por órgãos Municipais, Estaduais e Federais.
            </motion.h2>
          </div>
        </div>
      </div>

      <div className="marquee-mask">
        <Marquee gradient={false} speed={28} pauseOnHover>
          {CLIENT_LOGOS.map((src, i) => (
            <div
              key={i}
              data-testid={`client-logo-${i}`}
              className="mx-10 md:mx-14 h-14 md:h-16 flex items-center justify-center opacity-70 hover:opacity-100 transition-opacity"
            >
              <img
                src={src}
                alt="Cliente licito.guru"
                className="max-h-full max-w-[160px] object-contain"
                loading="lazy"
              />
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
